import React, { useEffect, useState } from 'react';
import { Buffer } from 'buffer';
import { API_ROUTES, API_DOMAIN, headers, MAIN_APP_FRONTEND_DOMAIN } from '../../Reusable_Components/apiConfig';
import axios from 'axios';
import { Modal } from 'react-bootstrap';

const Login = () => {
  const [username, setUsername] = useState(null);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const handleLeave = () => {
      setShow(true);
    };

    window.addEventListener('beforeunload', handleLeave);

    const encryptedUsername = new URLSearchParams(window.location.search).get('key');

    if (encryptedUsername) {
      const decryptedUsername = Buffer.from(encryptedUsername, 'base64').toString('utf-8');
      setUsername(decryptedUsername);
      verifyHandshake(decryptedUsername);
    } else {
      const token = localStorage.getItem('finance_accounting_token');
      if(!token)
      {
        window.location.href = MAIN_APP_FRONTEND_DOMAIN;
      } 
      else
      {
        window.open('/dashboard', '_self');
      }  
    }
    return () => {
      window.removeEventListener('beforeunload', handleLeave);
      
    };
  }, []);

  const verifyHandshake = async (username) => {
    try {     
    const data = { username: username };    
    const response = await axios.post(`${API_DOMAIN}${API_ROUTES.verifyHandshake}`, data);
    localStorage.removeItem('finance_accounting_token')
    localStorage.setItem('finance_accounting_token',response.data.token)
    
    if (localStorage.getItem('finance_accounting_token')) {      
        window.open('/dashboard', '_self');      
    }

    } catch (error) {
      console.error(error);
    }


  };



  return (
    <div>
      
<Modal id="unique-modal" show={false} onHide={() => setShow(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Warning</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    You cannot leave or click out of this page.
  </Modal.Body>
  <Modal.Footer>
    <button onClick={() => setShow(false)}>Stay on Page</button>
  </Modal.Footer>
</Modal>
Logging You Into The Accounting Module
    </div>
  );
};

export default Login;